import { JetView } from 'webix-jet'; // Importing JetView for creating a view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the filter reports view.
 * @extends JetView
 */
export default class FilterReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration

        // Configuration for the date picker component
        const fecha = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker', // Name of the input
                    id: 'Datepicker', // ID of the input
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Making the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Configuration for the transaction ID section
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [], // Placeholder for future rows
        };

        // Upper section layout containing date picker and transaction ID
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout identifier
                    margin: 10,
                    cols: [fecha, transactionId], // Columns containing fecha and transactionId
                },
            ],
        };

        // Button configuration for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button for clearing the form
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatic width adjustment
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the form fields
                    },
                },
                {
                    view: 'button', // Button for submitting the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type indicating form submission
                    autowidth: true, // Automatic width adjustment
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('userAffiliates:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };

        // Returning the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
